<template>
  <div
    class="app-container"
    style="display: flex;flex-direction: row;align-items: start;justify-content: space-between;"
  >
    <SelectDictType
      v-model="listQuery.type_id"
      style="width: 18%;"
      @setCode="setCode"
      @change="loadData"
    />
    <el-row style="width: 80%">
      <div class="filter-container">
        <el-form ref="queryForm" inline :model="listQuery">
          <el-form-item prop="label">
            <el-input
              v-model="listQuery.label"
              placeholder="请输入字典标签"
              clearable
              @keyup.enter.native="SearchData"
            />
          </el-form-item>
          <el-form-item prop="value">
            <el-input
              v-model="listQuery.value"
              placeholder="请输入字典值"
              clearable
              @keyup.enter.native="SearchData"
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="SearchData"
            >搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>

        <!--        <el-input-->
        <!--          v-model="listQuery.code"-->
        <!--          placeholder="请输入字典标示"-->
        <!--          style="width: 300px;"-->
        <!--          clearable-->
        <!--          @change="SearchData"-->
        <!--          @keyup.enter.native="SearchData"-->
        <!--        />-->
      </div>
      <!--动作组-->
      <div class="action-container">
        <el-button-group>
          <!-- 弹窗层编辑 -->
          <el-button
            v-auth="'DictData.create'"
            class="action-item"
            type="primary"
            icon="el-icon-edit"
            @click="HandleCreate"
          >添加
          </el-button>
          <el-button
            v-auth="'DictData.delete'"
            class="action-item"
            icon="el-icon-delete"
            @click="BatchDelete"
          >删除
          </el-button>
        </el-button-group>
      </div>
      <!--表开始-->
      <el-table
        ref="singleTable"
        v-loading="listLoading"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%"
        @sort-change="sortChange"
      >
        <!--列开始-->
        <el-table-column type="selection"></el-table-column>
        <!-- <el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" /> -->
        <el-table-column
          align="center"
          prop="type_id"
          label="字典类型ID "
        ></el-table-column>
        <el-table-column
          align="center"
          prop="label"
          label="字典标签 "
        ></el-table-column>
        <el-table-column
          align="center"
          prop="value"
          label="字典值 "
        ></el-table-column>
        <el-table-column
          align="center"
          prop="code"
          label="字典标示 "
        ></el-table-column>
        <el-table-column
          align="center"
          prop="sort"
          label="排序"
        ></el-table-column>
        <el-table-column align="center" prop="status" label="状态 ">
          <template #default="scope">
            <el-tag v-if="scope.row.status === 2" type="danger">停用</el-tag>
            <el-tag v-if="scope.row.status === 1" type="success">正常</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="create_time"
          label="创建时间 "
          width="180"
        ></el-table-column>

        <el-table-column
          align="center"
          prop=""
          label="操作"
          width="200"
          class-name="action"
        >
          <template slot-scope="scopes">
            <el-button
              v-auth="'DictData.edit'"
              icon="el-icon-edit"
              type="primary"
              size="mini"
              @click="HandleUpdate(scopes.row)"
            >
              编辑
            </el-button>
            <el-button
              v-auth="'DictData.delete'"
              icon="el-icon-delete"
              type="danger"
              size="mini"
              @click="RowDelete(scopes.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
        <!--列结束-->
      </el-table>
      <!--分页-->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="loadData"
      />
    </el-row>
    <!--弹窗编辑/新增窗体-->
    <el-dialog
      :title="dialogStatus == 'create' ? '新增' : '编辑'"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        ref="dataForm"
        :rules="rules"
        :model="temp"
        label-position="left"
        label-width="110px"
        style="width: 100%;"
      >
        <el-form-item label="字典类型ID" prop="type_id">
          <el-select v-model="temp.type_id" placeholder="请选择">
            <el-option
              v-for="item in dict_type"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              @click.native="dictType(item)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="字典标示" prop="code">
          <el-input v-model="temp.code" disabled />
        </el-form-item>

        <el-form-item label="字典标签" prop="label">
          <el-input v-model="temp.label" />
        </el-form-item>
        <el-form-item label="字典键值" prop="value">
          <el-input v-model="temp.value" />
        </el-form-item>

        <el-form-item label="排序" prop="sort">
          <el-input-number
            v-model="temp.sort"
            :min="1"
            :max="9999"
            :step="1"
            :precision="0"
          />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio v-model="temp.status" :label="1">正常</el-radio>
          <el-radio v-model="temp.status" :label="2">停用</el-radio>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="temp.remark" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmData">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/system/dict_data' // 和数据交互相关写在api 方便复用
import dict_type from '@/api/system/dict_type' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
// import WangEditor from '@/components/WangEditor'
// import FileList from '@/components/attachment/FileList'
import SelectDictType from './components/SelectDictType.vue'

export default {
  name: 'DictData',
  components: {
    Pagination,
    // WangEditor,
    // FileList,
    SelectDictType
  },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      // 校验
      rules: {},
      temp: {},
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'DESC', // 默认排序方式,
        sort: 'id'
      },
      dict_type: []
    }
  },
  created() {
    this.loadData()
    dict_type
      .Query({ sort: 'id', order: 'desc', isPaginator: false, status: 1 })
      .then(response => {
        this.dict_type = response.data
      })
  },
  methods: {
    HandleCreate() {
      if (this.listQuery.type_id === undefined) {
        this.$message({ message: '请先选择左侧分类', type: 'error' })
        return
      }
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
    },
    dictType(row) {
      this.temp.code = row.code
    },
    setCode(row) {
      this.listQuery.code = row.code
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        order_no: 1,
        type_id: this.listQuery.type_id,
        code: this.listQuery.code,
        label: '',
        value: '',
        sort: 1,
        remark: '',
        status: 1
      }
    }
  }
}
</script>
